export default "__VITE_ASSET__DOJqnM75__"